import { render, staticRenderFns } from "./MarketplaceResource.vue?vue&type=template&id=163365e9&scoped=true"
import script from "./MarketplaceResource.vue?vue&type=script&lang=js"
export * from "./MarketplaceResource.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceResource.vue?vue&type=style&index=0&id=163365e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163365e9",
  null
  
)

export default component.exports